(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jm-before-after-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jm-comparison-tabs')) {
    customElements.define(
      'jm-comparison-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.activate(tab.dataset.tabIndex));
            tab.addEventListener('keydown', (event) => this.onKeydown(event));
          });

          this.activate('1');
        }

        activate(index) {
          this.tabs.forEach((tab) => {
            const active = tab.dataset.tabIndex === index;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });

          this.panels.forEach((panel) => {
            const active = panel.dataset.panelIndex === index;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        }

        onKeydown(event) {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

          event.preventDefault();
          const current = this.tabs.indexOf(event.currentTarget);
          let next = current;

          if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;

          const tab = this.tabs[next];
          this.activate(tab.dataset.tabIndex);
          tab.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jm-customization-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('consultation-drawer')) {
    customElements.define(
      'consultation-drawer',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-consultation-dialog]');
          this.openButton = this.querySelector('[data-consultation-open]');
          this.closeButton = this.querySelector('[data-consultation-close]');

          this.openButton?.addEventListener('click', () => this.open());
          this.closeButton?.addEventListener('click', () => this.dialog.close());
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });

          if (this.querySelector('[data-form-status]')) this.open();
        }

        open() {
          if (!this.dialog?.open) this.dialog.showModal();
          this.dialog.querySelector('[data-form-status], input')?.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
